import React from 'react';
import AccountForm from './AccountForm';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { KEY } from 'web/components/utils/stripeKey';

const DebitCreditCard = ({ isOpen,pageData, modalType, toggle, response, callBackModal, type, onClickHander }) => {
  const stripePromise = loadStripe(KEY);
  return (<>
    <Elements stripe={stripePromise}>
      <AccountForm
        isOpen={isOpen}
        pageData={pageData}
        toggle={toggle}
        modalType={modalType}
        response={response}
        type={type}
        onClickHander={onClickHander}
        callBackModal={callBackModal}
         />
    </Elements>
  </>
  );
};

export default DebitCreditCard;
